var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_19_3750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5486 5.33325H9.45522C7.18322 5.33325 5.33789 7.17859 5.33789 9.45059V14.5439C5.33789 16.8159 7.18322 18.6613 9.45522 18.6613H14.5486C16.8206 18.6613 18.6659 16.8159 18.6659 14.5439V9.45059C18.6659 7.17859 16.8206 5.33325 14.5486 5.33325ZM17.1779 14.5493C17.1779 15.9999 15.9992 17.1839 14.5432 17.1839H9.44989C7.99922 17.1839 6.81522 16.0053 6.81522 14.5493V9.45592C6.81522 8.00525 7.99389 6.82125 9.44989 6.82125H14.5432C15.9939 6.82125 17.1779 7.99992 17.1779 9.45592V14.5493Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.5918C10.1225 8.5918 8.5918 10.1225 8.5918 11.9998C8.5918 13.8771 10.1225 15.4078 11.9998 15.4078C13.8771 15.4078 15.4078 13.8771 15.4078 11.9998C15.4078 10.1225 13.8771 8.5918 11.9998 8.5918ZM11.9998 14.0691C10.8585 14.0691 9.93046 13.1411 9.93046 11.9998C9.93046 10.8585 10.8585 9.93046 11.9998 9.93046C13.1411 9.93046 14.0691 10.8585 14.0691 11.9998C14.0691 13.1411 13.1411 14.0691 11.9998 14.0691Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7349 9.38403C16.2801 9.29566 16.6504 8.78207 16.562 8.2369C16.4736 7.69173 15.96 7.32143 15.4148 7.40981C14.8697 7.49818 14.4994 8.01177 14.5878 8.55694C14.6761 9.10211 15.1897 9.47241 15.7349 9.38403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_3750",
    x1: 2.86288,
    y1: 21.1371,
    x2: 19.9162,
    y2: 4.08379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.10bce1717e5756347551e14cb7747875.svg";
export { ForwardRef as ReactComponent };